import InputMask from 'react-input-mask';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaCheck, FaXmark } from 'react-icons/fa6';
import { DateBox } from 'devextreme-react';
import useCheckUserRole from '../../BasketPage/Hooks/useCheckUserRole.ts';
import { UserRole } from '../../../Data/UserRolesEnum.ts';

const InputAuthorizedPersonPanel = ({ authorizedPerson, handleEditPerson, handleAddEditPerson, handleDateChange, handleChangeAuthorizationType, dateToRef }) => {
    const { t } = useTranslation();
    const { isUserHasAccess } = useCheckUserRole()

    return <>
        {!isUserHasAccess(UserRole.Admin) && <div className="d-flex justify-content-center align-items-center ms-3 me-3 mt-2 mb-2">
            <h5 className='error-text-color '>Tylko operator z uprawnieniami administratora może definiować osoby upoiważnione do odbioru.
                Dodana osoba będzie dotyczyła tylko tego konkretnego zamówienia</h5>
        </div>}
        <div className="cont profile-details-info">
            <h3 className="checkbox-list-title">{t("user")}</h3>
            <div className="row data-container">
                <div className='col-12 col-md d-flex'>
                    <Form.Control name='name' placeholder={t("name")} maxLength={15} value={authorizedPerson.name} onChange={handleEditPerson} autoFocus required />
                    <span className='error-text-color'>&nbsp;*</span>
                </div>
                <div className="col-12 col-md mt-2 mt-md d-flex">
                    <Form.Control name='surname' placeholder={t("surname")} maxLength={30} value={authorizedPerson.surname} onChange={handleEditPerson} required />
                    <span className='error-text-color'>&nbsp;*</span>
                </div>
            </div>
            <div className="row data-container">
                <div className="col-12 col-md d-flex">
                    <Form.Control name='position' placeholder={t("position")} maxLength={25} value={authorizedPerson.position} onChange={handleEditPerson} />
                    <span className='error-text-color'>&nbsp;&nbsp;&nbsp;</span>
                </div>
                <div className='col'>

                </div>
            </div>
            <h3 className="checkbox-list-title mt-4">{t("contact_data")}</h3>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <Form.Control name='email' type='email' placeholder={'E-mail (opcjonalne)'} maxLength={60} value={authorizedPerson.email} onChange={handleEditPerson} required />
                </div>
                <div className="col-12 col-md mt-2 mt-md d-flex">
                    <InputMask
                        mask="+48 999 999 999"
                        value={authorizedPerson.phoneNumber}
                        onChange={handleEditPerson}
                    >
                        {(inputProps) => (
                            <Form.Control
                                {...inputProps}
                                placeholder={t("phone")}
                                name='phoneNumber'
                                required
                            />
                        )}
                    </InputMask>
                    <span className='error-text-color'>&nbsp;*</span>
                </div>
            </div>
            <h3 className="checkbox-list-title mt-4">Data ważności upoważnienia</h3>
            <div className="row data-container">
                <div className="col-12 col-md">
                    <div className="term-item">
                        <span className="role-name">Czy upoważnienie terminowe?</span>
                        <div className={`custom-switch ${authorizedPerson.isExpAuthorization ? "active" : ""}`} onClick={() => handleChangeAuthorizationType()}>
                            <div className="custom-switch-circle">
                                {authorizedPerson.isExpAuthorization ? <FaCheck className='primary-accent-color-text' /> : <FaXmark />}
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-12 col-md mt-2 mt-md'>
                    <DateBox adaptivityEnabled={true} defaultValue={authorizedPerson.expirationDate.trim() ? authorizedPerson.expirationDate : ''} acceptCustomValue={false} onValueChanged={handleDateChange} ref={dateToRef} visible={authorizedPerson.isExpAuthorization} />
                </div>
            </div>
            <span>
                <span className='error-text-color'>*</span> Pole wymagane
            </span>
            <div className="row data-container mt-4">
                <div className="col-12 col-md d-grid">
                    <button className='btn-app-primary' onClick={handleAddEditPerson}>
                        {t("confirm")}
                    </button>
                </div>
                <div className="col">
                </div>
            </div>
        </div>
    </>
}

export default InputAuthorizedPersonPanel; 